import styled from '@emotion/styled'
import { Link } from 'gatsby'

export const ProfilesContainer = styled.div`
  ${tw`flex justify-center bg-alice-blue`}
`

interface ProfileButtonProps {
  tabCorporateGovernanceActive: boolean
}

export const CommonButtonStyles=styled('span')<ProfileButtonProps>`
${tw`bg-transparent rounded-none outline-none border-transparent p-0  pt-20 pb-10 text-dark-blue-three text-md`}
    text-decoration:none !important;
  cursor: pointer;
`

export const FinancialResultsButtonText = styled(CommonButtonStyles)`
  ${tw` mr-30 sm:ml-30`}
  border-bottom:${props =>
    !props.tabCorporateGovernanceActive ? '3px solid #19c7ff' : null};
  font-weight:${props => (!props.tabCorporateGovernanceActive ? '500' : 'normal')};
`

export const CorporateGovernanceButtonText = styled(CommonButtonStyles)`
${tw`sm:mr-30`}
  border-bottom:${props =>
    props.tabCorporateGovernanceActive ? '3px solid #19c7ff' : null};
  font-weight:${props => (props.tabCorporateGovernanceActive ? '500' : 'normal')};
    `
